/**
 * Client-side mirror of backend/src/game/dungeon-instance/sim/world-state.ts's
 * Formula 1 — display only (the server alone decides when a crank actually
 * completes). Lets the HUD show live progress instead of only SEALED /
 * CRANKING / OPEN.
 */
export const WORLD_STATE = {
  BASE_CRANK_MS: 10_000,
  ASSIST_FACTOR: 0.5,
  MAX_CRANKERS: 3,
  MAX_INTERACT_DISTANCE_M: 2.5,
} as const;

export function combinedRate(crankerCount: number): number {
  if (crankerCount <= 0) return 0;
  const n = Math.min(crankerCount, WORLD_STATE.MAX_CRANKERS);
  return 1 + (n - 1) * WORLD_STATE.ASSIST_FACTOR;
}

export interface PortcullisProgressInput {
  checkpointProgressMs: number;
  checkpointAt: number;
  activeCrankersCount: number;
}

export function accumulatedProgressMs(p: PortcullisProgressInput, now: number): number {
  const elapsed = Math.max(0, now - p.checkpointAt);
  return p.checkpointProgressMs + elapsed * combinedRate(p.activeCrankersCount);
}

export function crankProgressFraction(p: PortcullisProgressInput, now: number): number {
  return Math.min(1, accumulatedProgressMs(p, now) / WORLD_STATE.BASE_CRANK_MS);
}
